<template>
  <div class="container">
      <NavbarSimple :leftText="$t('common.dailyRevenueList')"></NavbarSimple>
      <div class="wrapper">
          <div class="block1">
              <div>
                <span>{{$t('productDetailsPage.investmentAmount')}}</span>
                <span>{{currrow.amount}} USDT</span>
            </div>
            <div>
                <span>{{$t('investPage.cycle')}}</span>
                <span>{{currrow.cycle}} {{$t('investPage.day')}}</span>
            </div>
            <div>
                <span>{{$t('productDetailsPage.dailyInterestRate')}}</span>
                <span>{{currrow.dailyInterestRate * 100}}%</span>
            </div>
            <div>
                <span>{{$t('investedListPage.investmentTime')}}</span>
                <span>{{currrow.createdAt}}</span>
            </div>
            <div>
                <span>{{$t('investedListPage.settlementTime')}}</span>
                <span>{{currrow.settlementTime}}</span>
            </div>
            <div>
                <span>{{$t('investedListPage.settlementAmount')}}</span>
                <span>{{currrow.settlementAmount}} USDT</span>
            </div>
        </div>
        <div class="block2">
            <div class="td">{{$t('common.date')}}</div>
            <div class="td">{{$t('common.amount')}}</div>
            <template v-for="elem of data.rows">
                <div class="td" :key="elem.id">{{elem.date}}</div>
                <div class="td" :key="elem.id">{{elem.amount}} USDT</div>
            </template>
            <div style="width:100%;display:flex;justify-content: flex-end;">
                <van-pagination v-model="page" @change="_fetch" :total-items="data.count" :show-page-size="size" mode="simple">
                    <template #prev-text>
                        <van-icon name="arrow-left" />
                    </template>
                    <template #next-text>
                        <van-icon name="arrow" />
                    </template>
                </van-pagination>
            </div>
        </div>
      </div>
  </div>
</template>

<script>
import NavbarSimple from '@/components/NavbarSimple.vue'
export default {
    name: 'dailyRevenueList',
    components: {
        NavbarSimple,
    },
    data() {
        return {
            page: 1,
            size: 10,
            data: {
                count: 0,
                rows: []
            },
            currrow: {}
        }
    },
    mounted() {
    this._fetch();
  },
  methods: {
    _fetch() {
        this.currrow = this.$route.params.elem;
        const amount = (this.currrow.settlementAmount / this.currrow.cycle).toFixed(2);
        const diffdays = this.moment().diff(this.currrow.createdAt, 'days');
        if (diffdays) {
            this.data.count = diffdays;
            this.data.rows = [];
            for (let i = diffdays; i > 0; i--) {
                this.data.rows.push({
                    date: this.moment(this.currrow.createdAt).add(i, 'days').format('YYYY-MM-DD HH:mm:ss'),
                    amount
                });
            }
        }
    }
  }
}
</script>

<style scoped lang="less">
.wrapper {
    margin-top: 4rem;
    padding: 4rem;
    font-size: 3.467rem;
    color: #000;
    background-color: @app-theme-color4;
    border: 0.267rem solid @app-theme-color1;
    border-radius: 5.333rem;
    display: flex;
    flex-direction: column;
    align-items: center;
    .block1 {
        background-color: #d6b593;
        border: 0.267rem solid #814000;
        color: #814000;
        border-radius: 4rem;
        padding: 3.888rem;
        width: 85rem;
        margin-top: 5.333rem;
        >div {
            display: flex;
            justify-content: space-between;
        }
    }
    .block2 {
        background-color: #d6b593;
        border: 0.267rem solid #814000;
        color: #814000;
        border-radius: 4rem;
        padding: 3.888rem;
        width: 85rem;
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
        margin-top: 5.333rem;
        .td {
            display: flex;
            justify-content: center;
            align-items: center;
            width: 50%;
            height: 8rem;
            border-radius: 0.8rem;
        }
    }
}
</style>